
export default function useEnvString () {
    return {
        VUE_APP_I18N_LOCALE: String(process.env.VUE_APP_I18N_LOCALE),
        VUE_APP_I18N_FALLBACK_LOCALE: String(process.env.VUE_APP_I18N_FALLBACK_LOCALE),
        VUE_APP_API_URL: String(process.env.VUE_APP_API_URL),
        VUE_APP_AUTH_URL: String(process.env.VUE_APP_AUTH_URL),
        VUE_APP_CS_URL: String(process.env.VUE_APP_CS_URL),
        VUE_APP_COMMON_URL: String(process.env.VUE_APP_COMMON_URL),
        VUE_APP_AUTH_RESOURCE_URL: String(process.env.VUE_APP_AUTH_RESOURCE_URL),
        VUE_APP_BOARD_API_URL: String(process.env.VUE_APP_BOARD_API_URL),
        VUE_APP_HYPER_V3_CONTENT: String(process.env.VUE_APP_HYPER_V3_CONTENT),
        VUE_APP_NAMESPACE: String(process.env.VUE_APP_NAMESPACE),
        VUE_APP_AUTH_CENTER_URL: String(process.env.VUE_APP_AUTH_CENTER_URL),
        VUE_APP_CARDPAY_COMPANY_TITLE: String(process.env.VUE_APP_CARDPAY_COMPANY_TITLE),
        VUE_APP_CARDPAY_BASIC_SHOP_ID: String(process.env.VUE_APP_CARDPAY_BASIC_SHOP_ID),
        VUE_APP_CARDPAY_REGULAR_SHOP_ID: String(process.env.VUE_APP_CARDPAY_REGULAR_SHOP_ID),
        VUE_APP_POPS_CLIENT_ID: String(process.env.VUE_APP_POPS_CLIENT_ID),
        VUE_APP_POPS_CLIENT_REDIRECT_URI: String(process.env.VUE_APP_POPS_CLIENT_REDIRECT_URI),
        VUE_APP_CARDPAY_USD_SHOP_ID: String(process.env.VUE_APP_CARDPAY_USD_SHOP_ID),
        VUE_APP_POPS_LOGIN: String(process.env.VUE_APP_POPS_LOGIN),
        VUE_APP_SERVICE: String(process.env.VUE_APP_SERVICE),
        VUE_APP_ENV: String(process.env.VUE_APP_ENV),
        VUE_APP_COMMON_LOGIN: String(process.env.VUE_APP_COMMON_LOGIN),
        VUE_APP_BILLING_URL: String(process.env.VUE_APP_BILLING_URL),
        VUE_APP_POPS_MY_ACCOUNT_URL: String(process.env.VUE_APP_POPS_MY_ACCOUNT_URL),
        VUE_APP_NAME: String(process.env.VUE_APP_NAME),
        VUE_APP_GA4_MEASUREMENT_ID: String(process.env.VUE_APP_GA4_MEASUREMENT_ID)
    }
}
